<template src="./template.html"></template>
<script>
  import _ from 'lodash';

  export default ({
    name: 'v-form-step',

    props: {
      refTitle: {
        type: String,
      },
      refAutoStep: {
        type: Boolean,
        default: false,
      },
      refStepNumber: {
        type: Number,
        default: null,
      },
    },

    data() {
      return {
        index: 0,
        children: [],
      };
    },

    mounted() {
      this.setChildren();
      this.pushStep();
      this.setIndex();
      this.$root.$on('add-step', (index) => {
        if (this.index >= index) {
          this.index += 1;
        }
      });

      this.$root.$on('remove-step', (index) => {
        if (this.index >= index) {
          this.index -= 1;
        }
      });
    },

    destroyed() {
      this.removeStep();
    },

    watch: {
      stepOptions() {
        this.updateStep();
      }
    },

    computed: {
      transition() {
        return this.$parent.transition;
      },
      isActive() {
        return this.index === this.$parent.activeIndex;
      },

      formNames() {
        const formNames = [];

        _.forEach(this.children, (child) => {
          let formName = '';

          // ステップ内に含まれるコンポーネントでフォーム以外(formNameを持たない)場合、continue
          if (!child.formName) {
            return;
          }

          // チェックボックスの場合、専用の処理が必要になるため、アスタリスクを含むキーとして返す。
          if (child.$options.name === 'v-form-check' && child.checkTypeIsArray) {
            formName = _.trimEnd([child.refNames.parent, '*', child.refNames.child].join('.'), '.');
          } else {
            formName = child.refName;
          }

          if (!_.includes(formNames, formName)) {
            formNames.push(formName);
          }
        });

        return formNames;
      },

      stepOptions() {
        return {
          title: this.refTitle,
          formNames: this.formNames,
          autoStep: this.refAutoStep,
        };
      }
    },

    methods: {
      /**
       * componentにstepのindexの値をセット
       */
      setIndex() {
        if (this.refStepNumber) {
          this.index = this.refStepNumber;
        } else {
          this.index = this.$parent.stepLength;
        }
      },

      /**
       * storeにstepのoptionをセット
       */
      pushStep() {
        if (this.refStepNumber) {
          this.$parent.steps.splice(this.refStepNumber - 1, 0, this.stepOptions);
          this.$root.$emit('add-step', this.refStepNumber);
        } else {
          this.$parent.steps.push(this.stepOptions);
        }
      },

      removeStep() {
        this.$parent.steps.splice(this.index - 1, 1);
        this.$root.$emit('remove-step', this.index);
      },

      updateStep() {
        if (this.$parent.steps[this.index - 1]) {
          this.$parent.steps[this.index - 1] = this.stepOptions;
        }
      },

      setChildren() {
        this.children.push(...this.$children);
        this.$children = this.children;
      },
    },
  });
</script>